<router-outlet></router-outlet>
<app-pwa-banner></app-pwa-banner>
